import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Tabs, Tab, Box, useMediaQuery, useTheme } from '@mui/material';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import './DepartmentDashboard.css';
import CopyrightIcon from '@mui/icons-material/Copyright';

// Import the two components
import DepartmentIndex from './index';
import QuestionierIndex from '../Questioner/index';

function DepartmentDashboard() {
    const [activeTab, setActiveTab] = useState(0);
    const history = useHistory();
    const { isAuthenticated, token, logout } = useAuth();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, token, logout]);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <div className="container mt-2 mx-auto" style={{
            maxWidth: isMobile ? '100%' : '98%',
            padding: isMobile ? '0 8px' : '0 16px'
        }}>
            
            {/* Modern Tabs with Card Style */}
            <Box sx={{
                background: 'white',
                borderRadius: isMobile ? '12px' : '16px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                overflow: 'hidden',
                marginBottom: isMobile ? 2 : 3,
                marginTop: isMobile ? '-10px' : '-30px'
            }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant={isMobile ? "fullWidth" : "standard"}
                    sx={{
                        borderBottom: '1px solid #f0f0f0',
                        padding: isMobile ? '4px 4px' : '4px 10px',
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: isMobile ? '11px' : '12.5px',
                            minHeight: isMobile ? '48px' : '10px',
                            minWidth: isMobile ? 'auto' : '90px',
                            padding: isMobile ? '8px 4px' : '12px 16px',
                            color: '#6b7280',
                            borderRadius: '12px',
                            margin: isMobile ? '0 1px' : '0 2px',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                background: 'rgba(102, 126, 234, 0.08)',
                                color: '#667eea',
                            },
                            '&.Mui-selected': {
                                color: '#667eea',
                                background: 'rgba(102, 126, 234, 0.1)',
                            }
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#667eea',
                            height: '3px',
                            borderRadius: '3px 3px 0 0',
                        }
                    }}
                >
                    <Tab
                        label={
                            <span style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: isMobile ? '4px' : '8px',
                                flexDirection: isMobile ? 'column' : 'row'
                            }}>
                                <span style={{ fontSize: isMobile ? '18px' : '14px' }}>🏢</span>
                                <span>Departments</span>
                            </span>
                        }
                    />
                    <Tab
                        label={
                            <span style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: isMobile ? '4px' : '8px',
                                flexDirection: isMobile ? 'column' : 'row'
                            }}>
                                <span style={{ fontSize: isMobile ? '18px' : '14px' }}>📋</span>
                                <span>Questionnaires</span>
                            </span>
                        }
                    />
                </Tabs>

                {/* Tab Content with Padding */}
                <Box sx={{ padding: isMobile ? '8px' : '7px' }}>
                    {activeTab === 0 && <DepartmentIndex />}
                    {activeTab === 1 && <QuestionierIndex />}
                </Box>
            </Box>

            {/* Modern Footer */}
            <div style={{
                position: 'fixed',
                bottom: '12px',
                right: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                padding: '0.3rem 0.65rem',
                background: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '14px',
                boxShadow: '0 1px 6px rgba(0, 0, 0, 0.06)',
                fontFamily: 'serif',
                fontWeight: 'bold',
                color: '#2c3e50',
                fontSize: '0.7rem',
                backdropFilter: 'blur(10px)'
            }}>
                <CopyrightIcon />
                <b>EFFTABS SOLUTIONS LLP</b>
            </div>
        </div>
    );
}

export default DepartmentDashboard;
